//JS for Content section
var csc = {

	start : function () {
	
		csc.toggleText();
		csc.productCarousels();
		csc.articleCarousels();
		csc.categoryCarousels();
		csc.imageCarousels();
		csc.matchHeightFunction();
		csc.personalShoppingCarousels();
		csc.giftCardsCarousels();
		csc.productCarouselXmas();
	},
	
	// show/hide text on mobile header banner
	toggleText : function () {

		$('.csc-header-banner').each(function() {

			$this = $(this);
			$el = $($this.find('.csc-header-banner-copy'));

			if($el.length){

				maxHeight = 36;
				curHeight = $el.height();

				if(curHeight > maxHeight){

					$el.addClass('csc-max-height');
					$el.addClass('loaded');

					$toggle = $($this.find('.js-csc-toggleText'));
					$toggle.css('display','block');

					ClickEventToggleText($toggle,$el, maxHeight, curHeight);

				}

			}
			
	

		});

		function ClickEventToggleText($toggle,$el, maxHeight, curHeight){


			$toggle.on('click',function(event){

			   event.preventDefault();

				if($el.hasClass('csc-max-height')) {
				   $el.animate({height:curHeight},300, function() {

				   		$toggle.text('Read less');

				    }).removeClass('csc-max-height');
				 } else { 
				   $el.animate({height:maxHeight},300, function() {

				   		$toggle.text('Read more');

					}).addClass('csc-max-height');
				 }

				});

		}

	
	},
	

	// product slick slider
	productCarousels : function(){


		if($('.csc-narrow-width .csc-product-carousel').length > 0){

		  $('.csc-narrow-width .csc-product-carousel').each(function (idx, item) {

			  	var csc_product_carousel_narrow_settings = {
			  	     slide: '.csc-product-carousel-slide',
			  	     dots: true,
			  	     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
			  	     arrows: true,
			  	     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
			  	     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
			  	     speed: 600,
			  	     centerMode: true,
			  	     centerPadding: '25%',
			  	     slidesToShow: 1,
			  	     mobileFirst: true,
			  	     responsive: [{

			  	         breakpoint: 767,
			  	         settings: {
			  	         	centerMode: false,
			  	            slidesToShow: 3,
			  	            slidesToScroll: 3
			  	          }

			  	       },{

			  	         breakpoint: 1023,
			  	         settings: {
			  	            slidesToShow: 4,
			  	            slidesToScroll: 4,
			  	            centerMode: false
			  	          }

			  	       }

			  	       ]

			  	     
			  	}

		  		$(this).slick(csc_product_carousel_narrow_settings);

		  });

		}


		if($('.csc-full-width .csc-product-carousel').length > 0){

		  $('.csc-full-width .csc-product-carousel').each(function (idx, item) {

  			var csc_product_carousel_full_settings = {
  			     slide: '.csc-product-carousel-slide',
  			     dots: true,
  			     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
  			     arrows: true,
  			     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
  			     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
  			     speed: 600,
  			     centerMode: true,
  			     centerPadding: '25%',
  			     slidesToShow: 1,
  			     mobileFirst: true,
  			     responsive: [{

  			         breakpoint: 767,
  			         settings: {
  			         	centerMode: false,
   			            slidesToShow: 2,
  			            slidesToScroll: 2
  			          }

  			       },{

  			         breakpoint: 1023,
  			         settings: {
  			            slidesToShow: 3,
  			            slidesToScroll: 3,
  			            centerMode: false

  			          }

  			       }
  			       ,{

  	   		         breakpoint: 1279,
  	   		         settings: {
  	   		            slidesToShow: 4,
  	   		            slidesToScroll: 4,
  	   		            centerMode: false
  	   		          }

  	   		       }
  	   		       ,{

  	   		         breakpoint: 1399,
  	   		         settings: {
  	   		            slidesToShow: 5,
  	   		            slidesToScroll: 5,
  	   		            centerMode: false
  	   		          }

  	   		       }


  			       ]

  			     
  			}


  			$(this).slick(csc_product_carousel_full_settings);


		  });

		}
		// Upsell carousel on PDP //
		if($('.csc-narrow-width .csc-product-upsell-carousel').length > 0 && ( $('.csc-product-upsell-carousel-slide').length > 1) ){

		  $('.csc-narrow-width .csc-product-upsell-carousel').each(function (idx, item) {
				if ( $('.csc-product-upsell-carousel-slide').length == 1 ) { 
					var slides_to_show = 1
				} else if ( $('.csc-product-upsell-carousel-slide').length == 2 ) {
					var slides_to_show = 2
					if ( screen.width <= 768 ) {
						$( '.csc-clean-carousel-navigation.csc-std-carousel-navigation').css({ display: "block"});
					}
				}	else {
					var slides_to_show = 2
					$( '.csc-clean-carousel-navigation.csc-std-carousel-navigation').css({ display: "block"});
				}
			  	var csc_product_carousel_narrow_settings = {
			  	     slide: '.csc-product-upsell-carousel-slide',
							 dots: false,
			  	     arrows: true,
			  	     prevArrow: $(this).parent().find('.csc-clean-carousel-arrow-prev'),
			  	     nextArrow: $(this).parent().find('.csc-clean-carousel-arrow-next'),
			  	     speed: 600,
			  	     centerMode: true,
			  	     centerPadding: '0px',
			  	     slidesToShow: 1,
			  	     mobileFirst: true,
			  	     responsive: [{
			  	         breakpoint: 767,
			  	         settings: {
			  	         	centerMode: false,
			  	            slidesToShow: 2,
			  	            slidesToScroll: 1
			  	          }
			  	       	},
								 	{
			  	         breakpoint: 1023,
			  	         settings: {
			  	            slidesToShow: slides_to_show,
			  	            slidesToScroll: 1,
			  	            centerMode: false
			  	          }
			  	       	},
								 	{
			  	         breakpoint: 1200,
			  	         settings: {
			  	            slidesToShow: slides_to_show,
			  	            slidesToScroll: 1,
			  	            centerMode: false
			  	          }
			  	       	}
					      ]
			  	}
		  		$(this).slick(csc_product_carousel_narrow_settings);
		  });
		} else {
			//console.log('just the one upsell');
		}
	},

	productCarouselXmas : function(){

		// 5 to view carousel on desktop - christmas landing page
		if($('.pageCarousel5toview').length > 0){

		  $('.pageCarousel5toview').each(function (idx, item) {

			  	var csc_product_carousel_narrow_settings_man = {
			  	     slide: '.csc-product-carousel-slide',
			  	     dots: true,
			  	     //appendDots: $(this).parent().find('.csc-std-carousel-dots'),
			  	     arrows: true,
			  	     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
			  	     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
			  	     speed: 600,
			  	     centerMode: true,
			  	     centerPadding: '25%',
			  	     slidesToShow: 2,
			  	     mobileFirst: true,
			  	     responsive: [{

			  	         breakpoint: 220,
			  	         settings: {
			  	         	centerMode: false,
			  	            slidesToShow: 2,
			  	            slidesToScroll: 2
			  	          }

			  	       },{

									breakpoint: 767,
									settings: {
										 slidesToShow: 3,
										 slidesToScroll: 3,
										 centerMode: false
									 }

								},{

			  	         breakpoint: 1023,
			  	         settings: {
			  	            slidesToShow: 5,
			  	            slidesToScroll: 5,
			  	            centerMode: false
			  	          }

			  	       }

			  	       ]

			  	     
			  	}

		  		$(this).slick(csc_product_carousel_narrow_settings_man);

		  });

		} 
	},

	// article slick slider
	articleCarousels : function(){


		if($('.csc-narrow-width.csc-article-carousel-vertical .csc-article-carousel').length > 0){

		  $('.csc-narrow-width.csc-article-carousel-vertical .csc-article-carousel').each(function (idx, item) {

			  	var csc_article_carousel_narrow_settings = {
			  	     slide: '.csc-article-carousel-slide',
			  	     dots: true,
			  	     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
			  	     arrows: true,
			  	     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
			  	     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
			  	     speed: 600,
			  	     centerMode: true,
			  	     centerPadding: '16%',
			  	     slidesToShow: 1,
			  	     mobileFirst: true,
			  	     responsive: [{

			  	         breakpoint: 767,
			  	         settings: {
			  	         	centerMode: false,
			  	            slidesToShow: 2,
			  	            slidesToScroll: 2
			  	          }

			  	       },{

			  	         breakpoint: 1023,
			  	         settings: {
			  	            slidesToShow: 2,
			  	            slidesToScroll: 2,
			  	            centerMode: false
			  	          }

			  	       }

			  	       ]

			  	     
			  	}

			  	$(this).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
			  	    
			  	    // equal heights on card
			  	    $(this).find('.csc-article-carousel-slide-content').matchHeight();

			  	});

		  		$(this).slick(csc_article_carousel_narrow_settings);

		  });

		}

		if($('.csc-narrow-width.csc-article-carousel-horizontal .csc-article-carousel').length > 0){

		  $('.csc-narrow-width.csc-article-carousel-horizontal .csc-article-carousel').each(function (idx, item) {

			  	var csc_article_carousel_narrow_settings = {
			  	     slide: '.csc-article-carousel-slide',
			  	     dots: true,
			  	     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
			  	     arrows: true,
			  	     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
			  	     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
			  	     speed: 600,
			  	     slidesToShow: 1,
			  	     mobileFirst: true,
			  	     responsive: [{

			  	         breakpoint: 767,
			  	         settings: {
			  	         	centerMode: false,
			  	            slidesToShow: 2,
			  	            slidesToScroll: 2
			  	          }

			  	       },{

			  	         breakpoint: 1023,
			  	         settings: {
			  	            slidesToShow: 2,
			  	            slidesToScroll: 2,
			  	            centerMode: false
			  	          }

			  	       }

			  	       ]

			  	     
			  	}

		  		$(this).slick(csc_article_carousel_narrow_settings);

		  });

		}


		if($('.csc-full-width.csc-article-carousel-vertical .csc-article-carousel').length > 0){

		  $('.csc-full-width.csc-article-carousel-vertical .csc-article-carousel').each(function (idx, item) {

  			var csc_article_carousel_full_settings = {
  			     slide: '.csc-article-carousel-slide',
  			     dots: true,
  			     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
  			     arrows: true,
  			     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
  			     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
  			     speed: 600,
  			     centerMode: true,
  			     centerPadding: '16%',
  			     slidesToShow: 1,
  			     mobileFirst: true,
  			     responsive: [{

  			         breakpoint: 767,
  			         settings: {
  			         	centerMode: false,
   			            slidesToShow: 1,
  			            slidesToScroll: 1
  			          }

  			       },{

  			         breakpoint: 1023,
  			         settings: {
  			            slidesToShow: 2,
  			            slidesToScroll: 2,
  			            centerMode: false

  			          }

  			       }
  			       ,{

 			         breakpoint: 1199,
 			         settings: {
 			            slidesToShow: 3,
 			            slidesToScroll: 3,
 			            centerMode: false

 			          }

 			       }
  			       ]

  			     
  			}


  			$(this).slick(csc_article_carousel_full_settings);


		  });

		}

		if($('.csc-full-width.csc-article-carousel-horizontal .csc-article-carousel').length > 0){

		  $('.csc-full-width.csc-article-carousel-horizontal .csc-article-carousel').each(function (idx, item) {

  			var csc_article_carousel_full_settings = {
  			     slide: '.csc-article-carousel-slide',
  			     dots: true,
  			     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
  			     arrows: true,
  			     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
  			     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
  			     speed: 600,
  			     slidesToShow: 1,
  			     mobileFirst: true,
  			     responsive: [{

  			         breakpoint: 767,
  			         settings: {
   			            slidesToShow: 1,
  			            slidesToScroll: 1
  			          }

  			       },{

  			         breakpoint: 1023,
  			         settings: {
  			            slidesToShow: 2,
  			            slidesToScroll: 2

  			          }

  			       }
  			       ]

  			     
  			}


  			$(this).slick(csc_article_carousel_full_settings);


		  });

		}

	},

	// category slick slider
	categoryCarousels : function(){


		if($('.csc-narrow-width .csc-category-carousel').length > 0){

		  $('.csc-narrow-width .csc-category-carousel').each(function (idx, item) {

			  	var csc_category_carousel_settings = {
			  	     slide: '.csc-category-carousel-slide',
			  	     dots: true,
			  	     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
			  	     arrows: true,
			  	     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
			  	     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
			  	     speed: 600,
			  	     centerMode: true,
			  	     centerPadding: '25%',
			  	     slidesToShow: 1,
			  	     mobileFirst: true,
			  	     responsive: [{

			  	         breakpoint: 767,
			  	         settings: {
			  	         	centerMode: false,
			  	            slidesToShow: 2,
			  	            slidesToScroll: 2
			  	          }

			  	       },{

			  	         breakpoint: 1023,
			  	         settings: {
			  	            slidesToShow: 4,
			  	            slidesToScroll: 4,
			  	            centerMode: false
			  	          }

			  	       }

			  	       ]

			  	     
			  	}

		  		$(this).slick(csc_category_carousel_settings);

		  });

		}

		if($('.csc-full-width .csc-category-carousel').length > 0){

		  $('.csc-full-width .csc-category-carousel').each(function (idx, item) {

			  	var csc_category_carousel_settings = {
			  	     slide: '.csc-category-carousel-slide',
			  	     dots: true,
			  	     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
			  	     arrows: true,
			  	     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
			  	     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
			  	     speed: 600,
			  	     centerMode: true,
			  	     centerPadding: '25%',
			  	     slidesToShow: 1,
			  	     mobileFirst: true,
			  	     responsive: [{

			  	         breakpoint: 767,
			  	         settings: {
			  	         	centerMode: false,
			  	            slidesToShow: 2,
			  	            slidesToScroll: 2
			  	          }

			  	       },{

			  	         breakpoint: 1023,
			  	         settings: {
			  	            slidesToShow: 2,
			  	            slidesToScroll: 2,
			  	            centerMode: false
			  	          }

			  	       }

			  	       ]

			  	     
			  	}

		  		$(this).slick(csc_category_carousel_settings);

		  });

		}

	},
	// personal shopping & Valet slick slider
	personalShoppingCarousels : function(){
		if ( screen.width <= 1030 ) {
			if($('.ps-carousel').length > 0){
				$('.ps-carousel').each(function (idx, item) {
						var personalShoppingCarousels_settings = {
								slide: '.ps-slider',
								dots: true,
								appendDots: $(this).parent().find('.csc-std-carousel-dots'),
								arrows: true,
								prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
								nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
								speed: 600,
								centerMode: false,
								centerPadding: '0px',
								autoplay: false,
								autoplaySpeed: 3000,
								slidesToShow: 2,
								initialSlide: 0,
								responsive: [{
									breakpoint: 520,
									settings: {
											slidesToShow: 1,
											slidesToScroll: 1,
											centerMode: true,
											centerPadding: '0px'
										}
								},{
									breakpoint: 768,
									settings: {
											slidesToShow: 2,
											slidesToScroll: 2,
											centerMode: false,
											centerPadding: '0px'
										}
								},{
									breakpoint: 1023,
									settings: {
										slidesToShow: 2,
										slidesToScroll: 2,
										centerMode: false,
										centerPadding: '0px'
									}

								},{
									breakpoint: 1024,
									settings: {
										settings: "unslick"
									}

								}]
						}
						$(this).slick(personalShoppingCarousels_settings);
				});
			}
		}
		
		
	},
	// giftcards product slider
	giftCardsCarousels : function(){
			
		if($('.gc-carousel').length > 0){
			$('.gc-carousel').each(function (idx, item) {
					var giftCardsCarousels_settings = {
							slide: '.gc-slider',
							dots: true,
							infinite: false,
							appendDots: $(this).parent().find('.csc-std-carousel-dots'),
							arrows: true,
							prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
							nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
							speed: 600,
							centerMode: false,
							autoplay: false,
							slidesToShow: 3,
							slidesToScroll: 3,
							responsive: [{
								breakpoint: 768,
								settings: {
										slidesToShow: 2,
										slidesToScroll: 2
									}
							}]
					}
					$(this).slick(giftCardsCarousels_settings);
			});
		}
		
		
	},

	// image slick slider
	imageCarousels : function(){


		if($('.csc-narrow-width .csc-image-carousel').length > 0){

		  $('.csc-narrow-width .csc-image-carousel').each(function (idx, item) {

			  	var csc_image_carousel_narrow_settings = {
			  	     slide: '.csc-image-carousel-slide',
			  	     dots: true,
			  	     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
			  	     arrows: true,
			  	     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
			  	     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
			  	     speed: 600,
			  	     centerMode: true,
			  	     centerPadding: '20%',
			  	     slidesToShow: 1,
			  	     mobileFirst: true,
			  	     responsive: [{

			  	         breakpoint: 767,
			  	         settings: {
			  	         	centerMode: false,
			  	            slidesToShow: 3,
			  	            slidesToScroll: 3
			  	          }

			  	       },{

			  	         breakpoint: 1199,
			  	         settings: {
			  	            slidesToShow: 4,
			  	            slidesToScroll: 4,
			  	            centerMode: false
			  	          }

			  	       }

			  	       ]

			  	     
			  	}


			  	/*$(this).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
			  	    
			  	    // equal heights on card
			  	    $(this).find('.csc-matchheight-gatherer').matchHeight();

			  	});*/

		  		$(this).slick(csc_image_carousel_narrow_settings);

		  });

		}


		if($('.csc-full-width .csc-image-carousel:not(.csc-image-only-carousel)').length > 0){

		  $('.csc-full-width .csc-image-carousel:not(.csc-image-only-carousel)').each(function (idx, item) {

  			var csc_image_carousel_full_settings = {
  			     slide: '.csc-image-carousel-slide',
  			     dots: true,
  			     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
  			     arrows: true,
  			     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
  			     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
  			     speed: 600,
  			     centerMode: true,
  			     centerPadding: '20%',
  			     slidesToShow: 1,
  			     mobileFirst: true,
  			     responsive: [{

  			         breakpoint: 767,
  			         settings: {
  			         	centerMode: false,
   			            slidesToShow: 1,
  			            slidesToScroll: 1
  			          }

  			       },{

  			         breakpoint: 1023,
  			         settings: {
  			            slidesToShow: 2,
  			            slidesToScroll: 2,
  			            centerMode: false

  			          }

  			       }	       

  			       ]

  			     
  			}


  			$(this).slick(csc_image_carousel_full_settings);


		  });

		}

		if($('.csc-full-width .csc-image-only-carousel').length > 0){

		  $('.csc-full-width .csc-image-only-carousel').each(function (idx, item) {

  			var csc_image_carousel_full_settings = {
  			     slide: '.csc-image-carousel-slide',
  			     dots: true,
  			     appendDots: $(this).parent().find('.csc-std-carousel-dots'),
  			     arrows: true,
  			     prevArrow: $(this).parent().find('.csc-std-carousel-arrow-prev'),
  			     nextArrow: $(this).parent().find('.csc-std-carousel-arrow-next'),
  			     speed: 600,
  			     centerMode: true,
  			     centerPadding: '25%',
  			     slidesToShow: 1,
  			     mobileFirst: true,
  			     responsive: [{

  			         breakpoint: 767,
  			         settings: {
  			         	centerMode: false,
   			            slidesToShow: 2,
  			            slidesToScroll: 2
  			          }

  			       },{

  			         breakpoint: 1023,
  			         settings: {
  			            slidesToShow: 4,
  			            slidesToScroll: 4,
  			            centerMode: false

  			          }

  			       }
  			       ,{

  	   		         breakpoint: 1399,
  	   		         settings: {
  	   		            slidesToShow: 5,
  	   		            slidesToScroll: 5,
  	   		            centerMode: false
  	   		          }

  	   		       }		       

  			       ]

  			     
  			}


  			$(this).slick(csc_image_carousel_full_settings);


		  });

		}


	},

	// add elements here in matcheight needed
	matchHeightFunction : function(){
		if ($.isFunction(window.matchHeight)) {
			// equal heights on article style cards
			if($('.csc-article-card-container .csc-article-card').length > 0){
				$('.csc-article-card-container .csc-article-card').matchHeight();
			}

			// equal heights on image style cards
			if($('.csc-image-card-container .csc-image-card').length > 0){
				$('.csc-image-card-container .csc-image-card').matchHeight();
			}

			// equal heights on image style cards
			if($('.csc-narrow-width .csc-image-carousel').length > 0){
				$('.csc-narrow-width .csc-image-carousel').matchHeight();
			}
		}
	}

	
};
$(document).ready(csc.start);
$(window).bind("load", function() {
	
});

//smart resize
(function($,sr){

  // debouncing function from John Hann
  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/

  var debounce = function (func, threshold, execAsap) {
      var timeout;

      return function debounced () {
          var obj = this, args = arguments;
          function delayed () {
              if (!execAsap)
                  func.apply(obj, args);
              timeout = null;
          };

          if (timeout)
              clearTimeout(timeout);
          else if (execAsap)
              func.apply(obj, args);

          timeout = setTimeout(delayed, threshold || 100);
      };
  }
  // smartresize 
  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery,'smartresize');

// usage:
$(window).smartresize(function(){

	
});

// plugins
/*
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});

$slick_slider = $('.ps-carousel');
$window = $(window);
$window.on('resize', function() {
  if (window.innerWidth >= 1024) {
		if ($slick_slider.hasClass('slick-initialized')) {
			$slick_slider.slick('unslick');
			//console.log($window.width())
			//console.log('UNSLICKED PS Carousel')
			// do nothing
		} 
	} else {
		if ($slick_slider.hasClass('slick-initialized')) {
			// do nothing 
		} else {
			csc.personalShoppingCarousels();
		}
		
	}
}); 

